<template>
  <div
    :id="component_data.id"
    class="display-mobile custom_wrapper font-responsive"
  >
    <div
      class="custom_4w_contents w-5/6 mobile:w-full mobile:flex-column mx-auto"
    >
      <div class="four_widgets_image-center">
        <img class="image_center" :src="component_data.params.image_center" />
      </div>
      <div class="four_widgets_container">
        <SingleWidgetInFourWidgetsSection
          v-for="(data, index) in component_data.params.widget_content"
          :key="index"
          :data="data"
          :index="index"
          :component_data="component_data"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SingleWidgetInFourWidgetsSection from "@/components/LpSections/SingleWidgetInFourWidgetsSection";

export default {
  props: ["component_data"],
  data() {
    return {
  
    };
  },

  mounted() {
    this.$nextTick(() => {});
  },
  components: {
    SingleWidgetInFourWidgetsSection,
  },
};
</script>

<style lang="scss">
.card_container {
  perspective: 1200px;
  width: 45%;
  transform-style: preserve-3d;
}

.display-mobile {
  @media screen and (max-width: 991px) {
    display: none;
  }
}
.custom_wrapper {
  position: relative;
  margin: 60px 0;
}

.custom_4w_contents {
  position: relative;
  margin: 0 auto;
  display: flex;
  align-items: center;
  max-width: 1920px;
}

//FOUR WIDGETS SECTION

.four_widgets_container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;
}

.four_widgets_image-center {
  display: flex;
  position: absolute;
  width: 26vw;
  right: 50%;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  transform: translate(50%);
  z-index: 2;
  @media screen and (max-width: 1400px) {
    width: 20vw;
  }
  .image_center {
    width: 100%;
    height: auto;
    max-width: 650px;
  }
}

</style>
